import { combineReducers } from 'redux';
import getstream from './getstream.reducer';

const getstreamReducers = combineReducers({
	getstream,
});

export default getstreamReducers;